/** @jsx jsx */

import { Colors } from '@zapier/design-system-revenue/src/constants';
import { css, jsx } from '@emotion/core';

import { formatCompanyName } from './formatCompanyName';

type Props = {
  accountName?: string | null | undefined;
  companyName?: string | null | undefined;
  heading: string;
  subheading?: string;
};

const accountNameCss = css`
  text-decoration: underline;
`;

const headerCss = css`
  margin-bottom: 4rem;
`;

const headingCss = css`
  color: ${Colors.deepSpace};
  font-size: 1.8em;
  font-weight: 600;
  margin-top: 1em;
  padding: 0;
  text-align: center;
`;

const subHeadingCss = css`
  color: ${Colors.steel};
  font-size: 1em;
  margin-top: 20px;
  text-align: center;
`;

export const ChangePlanHeader = (props: Props) => (
  <header css={headerCss}>
    <h1 css={headingCss}>{props.heading}</h1>
    {props.subheading && (
      <div css={subHeadingCss}>
        {props.subheading}:{' '}
        <span css={accountNameCss}>{props.accountName}</span>{' '}
        {formatCompanyName(props.companyName)}
      </div>
    )}
  </header>
);
